import { InputNumber, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import {
  ListingDepositMethod,
  ListingDepositMethodTextMap,
  ListingDepositMethodUnitMap
} from '../../../enums/DepositMethod'

import { DepositInputProps } from './interface'

const options = mapNumberEnumOptions(ListingDepositMethodTextMap)

const Component = ({ disabled, value = {}, onChange }: DepositInputProps) => {
  const handleSelectChange = (depositMethod: ListingDepositMethod) => {
    onChange?.({
      ...value,
      depositMethod
    })
  }

  const handleInputChange = (depositValue: number | string | null) => {
    onChange?.({
      ...value,
      depositQuantity: isNil(depositValue) ? 0 : Number(depositValue)
    })
  }

  return (
    <Space.Compact block>
      <Select
        allowClear={false}
        disabled={disabled}
        options={options}
        value={value.depositMethod}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={disabled}
        value={value.depositQuantity}
        style={{
          width: '100%'
        }}
        onChange={handleInputChange}
      />
      {!isNil(value.depositMethod) && (
        <Space.Addon>
          {ListingDepositMethodUnitMap[value.depositMethod]}
        </Space.Addon>
      )}
    </Space.Compact>
  )
}

export const DepositInput = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
